import { Route } from 'src/routes/Route'

export const UnlockAccountCallRequiredRoute = Route({
  path: '/call-required',
  init: () => ({}),
  fromPath: () => ({}),
})
export type UnlockAccountCallRequiredRoute = Route<
  typeof UnlockAccountCallRequiredRoute
>
